export default "__VITE_ASSET__dde88127__"